<head>
  <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" rel="stylesheet" />
</head>

<!-- Sidebar Desktop -->
<aside class="sidebar" [class.sidebar-collapsed]="false">
  <div class="sidebar-header">
    <div class="logo-container">
      <div class="logo-icon-wrapper">
        <span class="material-symbols-outlined logo-icon">dashboard</span>
      </div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <ul class="nav-list">
      <!-- Tableau de bord -->
      <li class="nav-item" [class.active]="url === 'dashboard'">
        <a routerLink="/dashboard" class="nav-link">
          <span class="material-symbols-outlined nav-icon">dashboard</span>
          <span class="nav-text">Tableau de bord</span>
        </a>
      </li>

      <!-- Campagnes - Menu déroulant -->
      <li class="nav-item nav-item-dropdown" [class.expanded]="isCampagnesDropdownOpen">
        <div class="nav-link dropdown-toggle" (click)="toggleDropdown('campagnes')">
          <span class="material-symbols-outlined nav-icon">campaign</span>
          <span class="nav-text">Campagnes</span>
          <span *ngIf="needsSchedule" class="menu-schedule-alert" title="Il faut schedule">
            <span class="material-symbols-outlined text-xs text-amber-600">schedule</span>
          </span>
        </div>
        <ul class="submenu" [class.show]="isCampagnesDropdownOpen">
          <li class="submenu-item" [class.active]="url === 'suivi'">
            <a routerLink="/suivi" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">track_changes</span>
              <span>Suivi</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'archive'">
            <a routerLink="/archive" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">archive</span>
              <span>Archives</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Machines - Menu déroulant -->
      <li class="nav-item nav-item-dropdown" [class.expanded]="isMachinesDropdownOpen">
        <div class="nav-link dropdown-toggle" (click)="toggleDropdown('machines')">
          <span class="material-symbols-outlined nav-icon">devices</span>
          <span class="nav-text">Machines</span>
        </div>
        <ul class="submenu" [class.show]="isMachinesDropdownOpen">
          <li class="submenu-item" [class.active]="url === 'ports'">
            <a routerLink="/ports" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">settings_ethernet</span>
              <span>Gestion ports</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'system-connection'" *ngIf="isAdmin">
            <a routerLink="/system-connection" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">link</span>
              <span>Connexion système</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'strategies'" *ngIf="isAdmin">
            <a routerLink="/strategies" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">tune</span>
              <span>Stratégies</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'rechargement'" *ngIf="isAdmin">
            <a routerLink="/rechargement" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">account_balance_wallet</span>
              <span>Rechargement</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Système - Menu déroulant -->
      <li class="nav-item nav-item-dropdown" [class.expanded]="isSystemeDropdownOpen" *ngIf="isAdmin">
        <div class="nav-link dropdown-toggle" (click)="toggleDropdown('systeme')">
          <span class="material-symbols-outlined nav-icon">settings</span>
          <span class="nav-text">Système</span>
        </div>
        <ul class="submenu" [class.show]="isSystemeDropdownOpen">
          <li class="submenu-item" [class.active]="url === 'parametrage'">
            <a routerLink="/parametrage" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">settings</span>
              <span>Paramétrage</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'users'">
            <a routerLink="/users" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">people</span>
              <span>Utilisateurs</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'logs'">
            <a routerLink="/logs" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">description</span>
              <span>Logs</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'controle-cron'" [class.alert]="hasCronAlert">
            <a routerLink="/controle-cron" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">schedule</span>
              <span>Contrôle cron</span>
              <span class="nav-badge" [class.danger]="hasCronAlert" [class.success]="!hasCronAlert">
                {{ hasCronAlert ? lateCronCount + ' ⚠' : '✓' }}
              </span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Réception - Menu déroulant -->
      <li class="nav-item nav-item-dropdown" [class.expanded]="isReceptionDropdownOpen" *ngIf="isAdmin">
        <div class="nav-link dropdown-toggle" (click)="toggleDropdown('reception')">
          <span class="material-symbols-outlined nav-icon">inbox</span>
          <span class="nav-text">Réception</span>
        </div>
        <ul class="submenu" [class.show]="isReceptionDropdownOpen">
          <li class="submenu-item" [class.active]="url === 'services'">
            <a routerLink="/services" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">apps</span>
              <span>Services</span>
            </a>
          </li>
          <li class="submenu-item" [class.active]="url === 'webhooks'">
            <a routerLink="/webhooks" class="submenu-link">
              <span class="material-symbols-outlined submenu-icon">webhook</span>
              <span>Webhooks</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>

  <div class="sidebar-footer">
    <button class="logout-btn" (click)="deconnexion()" title="Se déconnecter">
      <span class="material-symbols-outlined">logout</span>
      <span class="logout-text">Déconnexion</span>
    </button>
  </div>
</aside>
